import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Social from '../section-components/social';
import Copyright from './copyright';
import shopData from "../../data/mainData.json";
import ContactForm from '../ContactForm';

class Footer_v1 extends Component {

	componentDidMount() {

		const $ = window.$;

		let publicUrl = process.env.PUBLIC_URL + '/'
		const minscript = document.createElement("script");
		minscript.async = true;
		minscript.src = publicUrl + "assets/js/main.js";

		document.body.appendChild(minscript);

		$('.go-top').find('a').on('click', function () {

			$(".quarter-overlay").fadeIn(1);

			$(window).scrollTop(0);

			setTimeout(function () {
				$(".quarter-overlay").fadeOut(300);
			}, 800);

		});


		$(document).on('click', '.theme-btn-1 ', function () {
			$('div').removeClass('modal-backdrop');
			$('div').removeClass('show');
			$('div').removeClass('fade');
			$('body').attr("style", "");
		});
	}

	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'
		let imgattr = "Footer logo"

		return (
			<footer className="ltn__footer-area  ">
				<div className="footer-top-area  section-bg-2 plr--5">
					<div className="container-fluid">
						<div className="row g-2">

  {/* ABOUT */}
  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
    <div className="footer-widget footer-about-widget">
      <div className="footer-logo">
        <div className="site-logo">
          <img src={shopData?.footer?.logo_img} alt="Logo" />
        </div>
      </div>
      <p>{shopData?.footer?.title}</p> <br />
      <p>{shopData?.footer?.title_1}</p>
    </div>
  </div>

  {/* QUICK LINKS */}
  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
    <div className="footer-widget footer-menu-widget clearfix">
      <h4 className="footer-title">Quick Links</h4>
      <div className="footer-menu go-top">
        <ul>
          <li><Link to={shopData?.footer?.nav_link_1}>{shopData?.footer?.nav_1}</Link></li>
          <li><Link to={shopData?.footer?.nav_link_2}>{shopData?.footer?.nav_2}</Link></li>
          <li><Link to={shopData?.footer?.nav_link_3}>{shopData?.footer?.nav_3}</Link></li>
          <li><Link to={shopData?.footer?.nav_link_4}>{shopData?.footer?.nav_4}</Link></li>
        </ul>
      </div>
    </div>
  </div>

  {/* PROJECTS */}
  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
    <div className="footer-widget footer-menu-widget clearfix">
      <h4 className="footer-title">Projects</h4>
      <div className="footer-menu go-top">
        <ul>
          {shopData?.propertyDetails?.map(item => (
            <li key={item.id}>
              <Link to={`/project/${item.slug_name}`}>{item.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>

  {/* OFFICES */}
  <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
  <div className="footer-widget footer-menu-widget">
    <h4 className="footer-title">Our Offices</h4>

    <div className="row">
      {shopData?.officeAddresses?.map((office) => (
        <div key={office.id} className="col-12 mb-4">
          <div className="footer-address">
            <h6 className="mb-2">{office.title}</h6>

            <ul>
              <li>
                <div className="footer-address-icon">
                  <i className="icon-placeholder" />
                </div>
                <div className="footer-address-info">
                  <p>{office.address}</p>
                </div>
              </li>

              <li>
                <div className="footer-address-icon">
                  <i className="icon-call" />
                </div>
                <div className="footer-address-info">
                  <p>
                    <a href={`tel:${office?.phone_1}`}>
                      {office?.phone_1}, {office?.phone_2}
                    </a>
                  </p>
                </div>
              </li>

              <li>
                <div className="footer-address-icon">
                  <i className="icon-mail" />
                </div>
                <div className="footer-address-info">
                  <p>
                    <a href={`mailto:${office.email}`}>
                      {office.email}
                    </a>
                  </p>
                </div>
              </li>
            </ul>
          </div>

          
										</div>
									))}
                  <div className="ltn__social-media mt-20">
            <Social />
          </div>

										<div className="product-ratting">
											<ul>
												<li className='me-2 text-white'>{shopData?.customer_ratings?.review_rate}</li>
												<li><a href="#"><i className="fas fa-star text-warning" /></a></li>
												<li><a href="#"><i className="fas fa-star text-warning" /></a></li>
												<li><a href="#"><i className="fas fa-star text-warning" /></a></li>
												<li><a href="#"><i className="fas fa-star text-warning" /></a></li>
												<li><a href="#"><i className="fas fa-star text-warning" /></a></li>
												<li className="review-total ms-2 text-white">
											<a
												href={shopData?.customer_ratings?.review_url}
												target="_blank"
												rel="noopener noreferrer"
											>
												( {shopData?.customer_ratings?.ratings_count} Reviews )
											</a>
											</li>

											</ul>
										</div>
									</div>
								</div>
								</div>
                

</div>

					</div>
				</div>
				<Copyright />
			</footer>
		)
	}
}


export default Footer_v1